import { render, staticRenderFns } from "./decoration.vue?vue&type=template&id=1e30f481&scoped=true"
import script from "./decoration.vue?vue&type=script&lang=js"
export * from "./decoration.vue?vue&type=script&lang=js"
import style0 from "./decoration.vue?vue&type=style&index=0&id=1e30f481&prod&scoped=true&lang=scss"
import style1 from "./decoration.vue?vue&type=style&index=1&id=1e30f481&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e30f481",
  null
  
)

export default component.exports